<template lang="pug">
Fragment
  .span-full.mt-3
    div.head.d-lg-flex
      .d-flex
        b-icon.no-print.mr-2(icon="clock-history" variant="dark" font-scale="1.5")
        h4.mb-0.title Historial
    hr.ot-divider
    b-table.mt-4(responsive :items="historial" :fields="fields")

    h4.text-center(v-if="!historial.length") No hay registros
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OVActionHistory',
  data() {
    return {
      fields: [
        { key: 'fecha_hora', label: 'Fecha y Hora' },
        { key: 'accion', label: 'Acción' },
        { key: 'responsable', label: 'Responsable' },
      ],
    }
  },
  computed: {
    ...mapGetters('OTStore', ['ot']),
    historial() {
      console.log(this.ot.datos_ov_asociada.historial_acciones)
      return this.ot && this.ot.datos_ov_asociada ? this.ot.datos_ov_asociada.historial_acciones : []
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  color: #23201C;
  font-weight: bold;
  font-size: 1.2em;
}
</style>
